import { useParams } from "react-router-dom";
import CourseDetail from "@/components/courses/course-detail";

export default function CourseDetailPage() {
  const { slug } = useParams();
  if (!slug) return null;
  return <CourseDetail courseId={slug} />;
}

